import { SignupContext, SignupProvider } from './context'
import { SignupForm } from './ui'

export const Signup = {
    Context: SignupContext,
    Provider: SignupProvider,
    Form: SignupForm,
}
